import { apiRequest } from '../api';
import type { ChartKind } from './coatype';

// The house template onto a client's chart (batch 5 round 7, COA-4 for the live template / COA-2) — the
// shapes server/src/routes/accounting.ts returns for GET /accounting/chart/template-diff, field for field.
// ⛔ The screen decides nothing here: what is missing, what conflicts and whether this login may approve
// (canApprove) are all the server's answers (server/src/services/accountingSetup.ts templateDiff).
// First initialisation of an empty chart still goes through api.acctCopyTemplate (no selection).

export type TemplateAccount = {
  templateId: string; code: string; nameTh: string; nameEn: string; cls: string; control: string;
  type: string; kind: ChartKind; group: string; sortOrder: number;
};
export type TemplateConflict = TemplateAccount & {
  /** The live account of this client that stands on the template account's code. templateId '' = the
   *  client built it; otherwise it is a renumbered copy of another template account. */
  occupiedBy: { id: string; code: string; nameTh: string; nameEn: string; cls: string; templateId: string; lines: number };
};
export type TemplateDiff = {
  /** Every row the chart holds, deleted ones included. 0 = never started (first initialisation). */
  chartRows: number;
  templateCount: number;
  missing: TemplateAccount[];
  conflicts: TemplateConflict[];
  /** Whether THIS login may add template accounts to a chart that already has accounts (an administrator). */
  canApprove: boolean;
};

export const coaSyncApi = {
  diff: (clientId: string): Promise<TemplateDiff> =>
    apiRequest('GET', `/accounting/chart/template-diff?clientId=${encodeURIComponent(clientId)}`),
  /** Add exactly these template accounts (an administrator's approval of the preview). */
  add: (clientId: string, templateIds: string[]): Promise<{ copied: number }> =>
    apiRequest('POST', '/accounting/chart/copy-template', { clientId, templateIds }),
};
